<div class="w-100 d-flex flex-column justify-content-start px-15px fs-15px">
  <div
    class="container border-bottom border-color-grey font-weight-bold fs-20px pl-0px py-15px"
  >
    Diamonds
    <select
      [ngModel]="activeTab"
      (ngModelChange)="onChange($event)"
      style="
        border: none;
        background: none;
        outline: none;
        border-bottom: solid 1px;
      "
      class="fs-20px font-weight-bold ddropdown"
    >
      <option
        [value]="CreatorDiamondsComponent.RECEIVED"
        class="font-weight-bold fs-20px"
      >
        received
      </option>
      <option
        [value]="CreatorDiamondsComponent.GIVEN"
        class="font-weight-bold fs-20px"
      >
        given
      </option>
    </select>
    by @{{ profile.Username }}
  </div>
  <div>
    <div class="fs-15px flex-grow-1">
      <div
        class="row no-gutters border-bottom border-color-grey fc-muted"
        *ngIf="!isLoading && diamondSummaryList.length > 0"
      >
        <div class="col-5 d-flex align-items-center py-15px mb-0">Username</div>
        <div class="col-4 text-left d-flex align-items-center py-15px mb-0">
          Most Diamonds
        </div>
        <div class="col-3 text-center d-flex align-items-center py-15px mb-0">
          Total Diamonds
        </div>
      </div>
      <div
        *ngIf="!isLoading && diamondSummaryList.length == 0"
        class="row no-gutters pt-10px"
      >
        <div class="d-flex align-items-center" style="margin-bottom: 0">
          <span>
            @{{ profile.Username }} has not {{ activeTab.toLowerCase() }} any
            diamonds yet.
            <a
              [routerLink]="[
                '/' + globalVars.RouteNames.USER_PREFIX,
                profile.Username
              ]"
              *ngIf="!showDiamondsGiven"
            >
              &nbsp;Be the first!
            </a>
          </span>
        </div>
      </div>
      <simple-center-loader *ngIf="isLoading"></simple-center-loader>
      <div *ngIf="!isLoading || loadingNewSelection">
        <div #uiScroll *uiScroll="let row of datasource">
          <div *ngIf="!row.totalRow && row.ProfileEntryResponse">
            <div
              class="link--unstyled cursor-pointer"
              [routerLink]="[
              '/' + globalVars.RouteNames.USER_PREFIX,
              showDiamondsGiven ? row.ProfileEntryResponse.Username : profile.Username,
              globalVars.RouteNames.DIAMONDS,
              showDiamondsGiven ? profile.Username : row.ProfileEntryResponse.Username,
            ]"
            >
              <div class="row no-gutters py-10px border-bottom mb-0">
                <div class="col-5 d-flex align-items-left mb-0">
                  <div
                    [routerLink]="[
                      '/' + globalVars.RouteNames.USER_PREFIX,
                      row.ProfileEntryResponse.Username
                    ]"
                    class="d-flex align-items-center link--unstyled"
                  >
                    <div
                      class="creator-profile-details__hodler-avatar mr-10px"
                      [avatar]="row.ProfileEntryResponse.PublicKeyBase58Check"
                    ></div>
                    <div
                      class="text-truncate"
                      style="font-size: 14px"
                      [ngStyle]="{
                        'max-width': globalVars.isMobile() ? '100px' : '200px'
                      }"
                    >
                      <span>{{ row.ProfileEntryResponse.Username }}</span>
                      <span
                        *ngIf="row.ProfileEntryResponse.IsVerified"
                        (click)="tooltip.toggle()"
                        class="ml-1 mb-1 cursor-pointer text-primary"
                        matTooltipClass="global__mat-tooltip global__mat-tooltip-font-size"
                        [matTooltip]="'This account is verified'"
                        #tooltip="matTooltip"
                      >
                        <i class="fas fa-check-circle fa-md align-middle"></i>
                      </span>
                      <div class="text-grey9 fs-12px">
                        {{
                          globalVars.nanosToUSD(
                            row.ProfileEntryResponse.CoinPriceDeSoNanos,
                            2
                          )
                        }}
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="col-4 mb-0 d-flex align-items-center justify-flex-start"
                >
                  <i
                    *ngFor="let diamond of counter(row.HighestDiamondLevel)"
                    class="icon-diamond fs-20px d-block"
                    style="margin-right: -7px"
                  ></i>
                </div>
                <div
                  class="col-3 mb-0 d-flex align-items-center justify-content-center"
                >
                  {{ row.TotalDiamonds }}
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="row.anonDiamondsRow">
            <div class="link--unstyled">
              <div class="row no-gutters py-10px border-bottom mb-0">
                <div class="col-5 d-flex align-items-left mb-0">
                  <div class="d-flex align-items-center link--unstyled">
                    <div
                      class="creator-profile-details__hodler-avatar mr-10px"
                      style="
                        background-image: url('/assets/img/default_profile_pic.png');
                      "
                    ></div>
                    <div
                      class="text-truncate"
                      style="font-size: 14px"
                      [ngStyle]="{
                        'max-width': globalVars.isMobile() ? '100px' : '200px'
                      }"
                    >
                      <span>Anonymous</span>
                    </div>
                  </div>
                </div>
                <div
                  class="col-4 mb-0 d-flex align-items-center justify-flex-start"
                >
                  <i
                    *ngFor="let diamond of counter(highestAnonDiamondLevel)"
                    class="icon-diamond fs-20px d-block"
                    style="margin-right: -7px"
                  ></i>
                </div>
                <div
                  class="col-3 mb-0 d-flex align-items-center justify-content-center"
                >
                  {{ totalAnonDiamonds }}
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="row.totalRow" class="row no-gutters font-weight-bold">
            <div class="col-4 py-15px mb-0">Total</div>
            <div class="col-4 py-15px mb-0"><!--Blank--></div>
            <div class="col-4 text-center py-15px mb-0">
              {{ totalDiamonds }} ≈
              {{ globalVars.abbreviateNumber(valueOfAllDiamonds(), 2, true) }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
